export default "__VITE_ASSET__02cca365__"